var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"richtext",domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)},on:{"click":_vm.handleClicks}})}
var staticRenderFns = []

export { render, staticRenderFns }